import axios from "axios";
import { Dialog, Notify } from "vant";
import store from "@/store";
import { getToken } from "@/utils/auth";

const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  baseURL: "api",
  timeout: 5000,
  validateStatus: status => {
    return status == 200 || status == 400 || status == 500;
  }
});

// request interceptor
service.interceptors.request.use(
  config => {
    console.log(config);
    if (store.getters.token) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers["X-Token"] = getToken();
    }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
// 返回报文拦截器 200/400/500 状态码走response 其他走error
service.interceptors.response.use(
  response => {
    if (response.data.code == "403") {
      Dialog.confirm({
        title: "登录",
        message: response.data.message,
        confirmButtonText: "登录",
        cancelButtonText: "取消",
        confirmButtonColor: "#ff976a"
      }).then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    }
    return response;
  },
  error => {
    Notify({ type: "warning", message: error.message });
    return Promise.reject(error);
  }
);

export default service;
